<template>
  <!-- 第一个div：容器内居中的灰色模块 -->
  <div
    class="flex justify-between items-center  h-[130px] pt-[25px] pr-[30px] pb-[10px] pl-[30px] rounded-[15px] bg-[#F2F3F5]"
  >
    <!-- 第一个div：今日已浏览 -->
    <div class="flex flex-col items-center">
      <div
        class="text-center w-[160px] h-[38px] font-semibold leading-[120%] tracking-[-0.01em] align-middle"
        :class="isEnglish ? 'text-[32px]' : 'text-[32px]'"
      >
        {{ todayViewCount }}
      </div>
      <div
        class="text-center h-[65px] font-normal text-[#00000099] flex items-center justify-center"
        :class="isEnglish ? 'w-[170px] text-[22px] leading-[100%] tracking-[-0.02em]' : 'w-[180px] text-[22px] '"
      >
        {{ todayViewedText }}
      </div>
    </div>

    <!-- 分割线 -->
    <div class="w-[1px] h-[60px] bg-black/10 mx-[10px]"></div>

    <!-- 第二个div：累计已阅读 -->
    <div class="flex flex-col items-center">
      <div
        class="text-center w-[160px] h-[38px] font-semibold leading-[120%] tracking-[-0.01em] align-middle"
        :class="isEnglish ? 'text-[32px]' : 'text-[32px]'"
      >
        {{ totalCount }}
      </div>
      <div
        class="text-center h-[65px] font-normal leading-[100%] tracking-[-0.02em] text-[#00000099] flex items-center justify-center"
        :class="isEnglish ? 'w-[170px] text-[22px]' : 'w-[180px] text-[22px] '"
      >
        {{ totalReadText }}
      </div>
    </div>

    <!-- 分割线 -->
    <div class="w-[1px] h-[60px] bg-black/10 mx-[10px]"></div>

    <!-- 第三个div：累计已浏览 -->
    <div class="flex flex-col items-center">
      <div
        class="text-center w-[160px] h-[38px] font-semibold leading-[120%] tracking-[-0.01em] align-middle"
        :class="isEnglish ? 'text-[32px]' : 'text-[32px]'"
      >
        {{ formattedDuration }}{{ durationUnit }}
      </div>
      <div
        class="text-center h-[65px] font-normal leading-[100%] tracking-[-0.02em] text-[#00000099] flex items-center justify-center"
        :class="isEnglish ? 'w-[170px] text-[22px]' : 'w-[180px] text-[22px] '"
      >
        {{ totalBrowsedText }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import { lang } from '../utils/lang';
import $t from '../utils/i18n';
import { ELang } from '@ark/utils';
interface Props {
  todayViewCount: number;
  totalCount: number;
  totalDurationSeconds: number;
}
const __sfc_main = {};
__sfc_main.props = {
  todayViewCount: {
    key: "todayViewCount",
    required: true,
    type: Number
  },
  totalCount: {
    key: "totalCount",
    required: true,
    type: Number
  },
  totalDurationSeconds: {
    key: "totalDurationSeconds",
    required: true,
    type: Number
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;

  // 语言判断
  const isEnglish = computed(() => lang === ELang.KV.EN);
  // 多语言文案（使用 computed 确保响应式）
  const todayViewedText = computed(() => $t('ProgressStats.todayViewed'));
  const totalReadText = computed(() => $t('ProgressStats.totalRead'));
  const totalBrowsedText = computed(() => $t('ProgressStats.totalBrowsed'));
  const secondUnit = computed(() => $t('ProgressStats.secondUnit'));
  const minuteUnit = computed(() => $t('ProgressStats.minuteUnit'));

  // 格式化时长：超过60秒转换为分钟（四舍五入）
  const formattedDuration = computed(() => {
    const seconds = props.totalDurationSeconds;
    if (seconds > 60) {
      // 超过60秒，转换为分钟并四舍五入
      return Math.round(seconds / 60);
    }
    return seconds;
  });

  // 时长单位：根据是否超过60秒选择秒或分钟
  const durationUnit = computed(() => {
    return props.totalDurationSeconds > 60 ? minuteUnit.value : secondUnit.value;
  });
  return {
    isEnglish,
    todayViewedText,
    totalReadText,
    totalBrowsedText,
    formattedDuration,
    durationUnit
  };
};
export default __sfc_main;
</script>
